/**
 * LinkListItem
 */
import React from 'react';
import clsx from 'clsx';
import { Link as LinkBase } from 'ui-component-library/base';
import Icon from 'ui-component-library/base/Icon';
/** Main description for this component. */
var LinkListItem = function (_a) {
    var text = _a.text, _b = _a.url, url = _b === void 0 ? '#' : _b, target = _a.target, _c = _a.LinkComponent, LinkComponent = _c === void 0 ? LinkBase : _c, icon = _a.icon, image = _a.image, external = _a.external;
    var Link = LinkComponent;
    return (React.createElement("li", { className: clsx('mb-3', icon && 'ml-4') }, url ? (React.createElement(Link, { to: url, className: clsx('text-teal hover:underline', (image || icon) && 'flex items-start'), target: target },
        icon && (React.createElement("span", null,
            React.createElement(Icon, { icon: icon, size: 0.75, className: "flex-shrink-0 mr-4 group-hover:translate-x-4 text-teal", "aria-hidden": true }))),
        image && (React.createElement("img", { className: "flex-shrink-0 flex-grow-0 h-8 w-auto mr-4 mb-2 inline-block", src: image, alt: "" })),
        React.createElement("span", null,
            text,
            ((target === '_blank' && external) || external) && (React.createElement("span", { className: "ml-2" },
                React.createElement(Icon, { icon: "externalLink", size: 0.75, className: "flex-shrink-0 group-hover:translate-x-4 text-teal", "aria-label": external ? 'Extern länk' : 'Öppnas i ett nytt fönster' })))))) : (React.createElement("div", { className: "flex" },
        image && (React.createElement("img", { className: "flex-shrink-0 flex-grow-0 h-8 w-auto mr-4 mb-2 inline-block", src: image, alt: "" })),
        React.createElement("p", { className: "flex-1 text-p" }, text)))));
};
export default LinkListItem;
